import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { discountsApi } from '../../api/discounts';
import type { DiscountRuleInput } from '../../types/ecommerce';

const KEY = ['discount-rules'] as const;

export function useDiscountRules() {
  return useQuery({ queryKey: KEY, queryFn: () => discountsApi.listRules() });
}

export function useCreateDiscountRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: DiscountRuleInput) => discountsApi.createRule(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateDiscountRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: DiscountRuleInput }) => discountsApi.updateRule(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteDiscountRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => discountsApi.removeRule(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDiscountRuleAnalytics(id: string | null) {
  return useQuery({
    queryKey: ['discount-rules', id, 'analytics'],
    queryFn: () => discountsApi.ruleAnalytics(id as string),
    enabled: !!id,
  });
}
